export const customerFields = ['user', 'username', 'status'];
